import React, { ReactNode } from 'react';

export interface HeaderNavBarProps {
  children: ReactNode;
}

const HeaderNavBar = ({ children }: HeaderNavBarProps): JSX.Element => {
  return <div className="usa-navbar">{children}</div>;
};

export default HeaderNavBar;
